<template>
  <div>
    <nav class="bar bar-nav">
      <a class="button button-link button-nav pull-left"  @click="gotolast()">
        <span class="icon icon-left"></span>返回
      </a>
      <h1 class="title">修改收货信息</h1>
    </nav>
    <div class="content">
      <div class="list-block">
        <ul>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">收货人</div>
                <div class="item-input">
                  <input type="text" v-model.trim="expressInfo.consignee" placeholder="text">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">联系电话</div>
                <div class="item-input">
                  <input type="text" v-model.trim="expressInfo.expressMobile" placeholder="Phone">
                </div>
              </div>
            </div>
          </li>
          <li class="align-top">
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">地址</div>
                <div class="item-input">
                  <input type="text"  id="city-picker">
                </div>
              </div>
            </div>
          </li>
          <li class="align-top">
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">详细地址</div>
                <div class="item-input">
                  <textarea v-model.trim="expressInfo.expressAddress"></textarea>
                </div>
              </div>
            </div>
          </li>
          <li class="align-top">
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">默认状态</div>
                <div class="item-input" style="margin-top: 1px;margin-left: 45%;">
                  <label class="label-switch">
                    <input type="checkbox"  v-model="expressInfo.isDefault">
                    <div class="checkbox"></div>
                  </label>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <div class="row">
          <div class="col-100"><a :href="href" @click="submit" class="button button-big button-fill button-success">确认修改</a></div>
        </div>
        <br>
        <div class="row">
          <div class="col-100"><a :href="href" @click="delAddress" class="button button-big button-fill button-danger">删除地址</a></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import $ from 'jquery'
  import {mapState, mapMutations} from 'vuex'
  import emkt from '../../../emkt'

  export default {
    created () {
      var express = this.expressInfo.province + ' ' + this.expressInfo.city + ' ' + this.expressInfo.district
      $('#city-picker').val(express)
    },
    data () {
      return {
        href: 'javascript:;'
      }
    },
    mounted () {
      $('#city-picker').cityPicker({toolbarTemplate: '<header class="bar bar-nav"> <button class="button button-link pull-right close-picker">OK</button> <h1 class="title">choose address</h1> </header>'
      })
      var express = this.expressInfo.province + ' ' + this.expressInfo.city
      console.log(express)
      $('#city-picker').val(express)
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ]),
      'expressInfo': {
        set () {
          return this.sessionInfo.expressAddress[this.$route.query.num]
        },
        get () {
          return this.sessionInfo.expressAddress[this.$route.query.num]
        }
      }
    },
    methods: {
      ...mapMutations([
        'EXPRESSADDRESS_UPDATE'
      ]),
      submit () {
        var _this = this
        var express = $('#city-picker').val()
        var preexpress = []
        preexpress = express.split(' ')
        if (preexpress[2] && preexpress[2] !== '') {
          _this.expressInfo.province = preexpress[0]
          _this.expressInfo.city = preexpress[1]
          _this.expressInfo.district = preexpress[2]
        } else {
          _this.expressInfo.city = preexpress[0]
          _this.expressInfo.district = preexpress[1]
        }
        _this.href = 'javascript:window.history.back()'
        let address = _this.expressInfo.expressAddress
        address = address.replace(/"/g, '“').replace(/'/g, '‘').replace(/\s/g, '')
        let isDefault = _this.expressInfo.isDefault
        if (isDefault === false) {
          isDefault = 0
        } else if (isDefault === true) {
          isDefault = 1
        }
        let params = {}
        params.customerNo = this.sessionInfo.customerInfo.customerNo
        params.creator = this.sessionInfo.customerInfo.customerName
        params.operator = this.sessionInfo.customerInfo.customerName
        params.expressAddressGuid = _this.expressInfo.expressAddressGuid
        params.isDefault = isDefault
        params.consignee = _this.expressInfo.consignee.replace(/\s/g, '')
        params.expressMobile = _this.expressInfo.expressMobile
        params.expressAddress = address
        params.province = _this.expressInfo.province
        params.city = _this.expressInfo.city
        params.district = _this.expressInfo.district
        params.addressSource = emkt.ADDRESS_SOURCE.ADDRESS_SOURCE_EMKT
        _this.gcapi('createOrUpdateAddress', params).then((response) => {
          if (response.body.code === 0) {
            $.toast('修改成功')
            _this.gotolast()
          }
          if (response.body.code === 1) {
            $.toast('出错')
          }
        })
      },
      delAddress () {
        var _this = this
        _this.href = 'javascript:window.history.back()'
        _this.gcapi('gcwwwifc/updateAddressStatus', {
          'expressAddressGuid': _this.expressInfo.expressAddressGuid
        }).then((response) => {
          if (response.body.code === 0) {
            $.toast('删除成功')
            _this.gotolast()
          } else {
            $.toast('出错')
          }
        }, (response) => {
          $.toast('请求错误')
        })
      },
      gotolast () {
        this.$router.push({name: 'address', query: {from: this.$route.query.from}, params: {order: this.$route.params.order}})
      }
    }
  }

</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// AddressModify.vue?501e5672